var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.125L5.7151 4.00223C5.80235 4.35333 5.846 4.52888 5.9321 4.6724C6.0083 4.79939 6.10825 4.90765 6.2255 4.99023C6.35795 5.0835 6.52 5.13079 6.8441 5.22531L9.5 6L6.8441 6.77469C6.52 6.86921 6.35795 6.9165 6.2255 7.00978C6.10825 7.09233 6.0083 7.2006 5.9321 7.32763C5.846 7.47111 5.80235 7.64667 5.7151 7.99778L5 10.875L4.2849 7.99778C4.19765 7.64667 4.154 7.47111 4.0679 7.32763C3.99168 7.2006 3.89175 7.09233 3.77453 7.00978C3.64205 6.9165 3.48 6.86921 3.1559 6.77469L0.5 6L3.1559 5.22531C3.48 5.13079 3.64205 5.0835 3.77453 4.99023C3.89175 4.90765 3.99168 4.79939 4.0679 4.6724C4.154 4.52888 4.19765 4.35333 4.2849 4.00223L5 1.125Z",
    fill: "#10A37F",
    stroke: "#10A37F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStarIcon);
export default __webpack_public_path__ + "static/media/GreenStarIcon.16a887f21b64e1dc6948edfe7294e9d7.svg";
export { ForwardRef as ReactComponent };